import { MarketingOverviewModel } from '../../../types';
import { hideMarketingBar, UserKeys } from '../../api/users-api';
import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';

import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Collapse from '@mui/material/Collapse';
import type { AlertColor } from '@mui/material/Alert';

interface MarketingBarProps {
  marketingOverview: MarketingOverviewModel;
}

export default function MarketingBar({ marketingOverview }: MarketingBarProps) {
  const queryClient = useQueryClient();
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
    hideMarketingBar();
    queryClient.invalidateQueries({
      queryKey: [UserKeys.UserSettings],
    });
  };

  function handleSeverity(): AlertColor {
    if (marketingOverview.barColor === 'error') {
      return 'error';
    } else if (marketingOverview.barColor === 'warning') {
      return 'warning';
    } else if (marketingOverview.barColor === 'info') {
      return 'info';
    } else {
      return 'info';
    }
  }

  return (
    <Collapse in={open}>
      <Alert
        onClose={
          marketingOverview?.barType === 'Permanent' ? undefined : handleClose
        }
        severity={handleSeverity()}
        variant="filled"
        sx={{
          width: '100%',
          borderRadius: 0,
          alignItems: 'center',
          '& .MuiAlert-message': {
            p: 0,
          },
        }}
      >
        <Stack
          flexDirection="row"
          justifyContent="space-between"
          gap={2}
          alignItems="center"
        >
          {marketingOverview!.title}
          {marketingOverview?.hasButton && (
            <Button
              color="inherit"
              size="small"
              variant="outlined"
              component="a"
              href={
                marketingOverview.url.startsWith('http')
                  ? marketingOverview.url
                  : `https://${marketingOverview.url}`
              }
              target="_blank"
              rel="noopener noreferrer"
            >
              {marketingOverview?.buttonText}
            </Button>
          )}
        </Stack>
      </Alert>
    </Collapse>
  );
}
